import { Injectable } from '@angular/core';
import { GpkgAutoStyleHandler, GpkgAutoStyleType, detectGpkgAutoStyle } from '@luzula/luzula-lib';
import { OptionService } from '../option.service';

/**
 * Handler für die automatische Erkennung von Bohrpunkte-Styles in GeoPackage-Dateien.
 * Erkennt standort, humusform und haken Layer anhand ihrer Attributnamen.
 *
 * Delegiert an die gemeinsame Erkennung `detectGpkgAutoStyle` in luzula-lib, damit
 * Lade-Pfad (dieser Handler) und Render-Pfad (GpkgRenderingService) nicht
 * auseinanderdriften (eine Quelle der Wahrheit).
 */
@Injectable({ providedIn: 'root' })
export class BohrpunktGpkgAutoStyleHandler implements GpkgAutoStyleHandler {
	constructor(private option: OptionService) {}

	/**
	 * Erkennt den Autostyle-Typ anhand der Attributnamen (case-insensitiv).
	 * - standort: LBFO1 oder STGR1
	 * - humusform: HUFO1
	 * - haken: SYMBOL + ART + ANGLE
	 */
	detectAutoStyle(attributeNames: string[]): GpkgAutoStyleType {
		return detectGpkgAutoStyle(attributeNames);
	}

	/**
	 * Prüft, ob ein HUFO-Wert eine ECHTE Humusform ist — mit derselben Regel wie
	 * die Feld-Validierung (Kombinatorik-Sonderregel ODER Listen-Eintrag), die in
	 * der Option "HumusformNeu" als Regex hinterlegt ist. So werden Fremd-GPKGs mit
	 * zufälliger HUFO-Spalte (z.B. Wert "FGK_nk") nicht als Humusform eingefärbt
	 * oder beschriftet. Ohne hinterlegte Regel wird nicht eingeschränkt.
	 */
	isValidHumusValue(value: string): boolean {
		const v = (value ?? '').trim();
		if (!v) return false;
		const regex = this.option.option('HumusformNeu')?.regex;
		if (!regex) return true;
		try {
			return new RegExp(regex).test(v);
		} catch {
			return true;
		}
	}
}
